module.exports = __webpack_public_path__ + "static/media/b2_p5_melody.97390a86.mp3";